import React from 'react';
import { twMerge } from 'tailwind-merge';
import { formatPrice } from '../../../utils/formatter';

const Price = ({ price, className }) => (
  <div className={twMerge('flex w-full justify-end gap-2 mt-4 md:mt-6 items-center', className)}>
    <div className="text-xs md:text-base">Загалом:</div>
    <div className="text-xs md:text-base font-header2">{formatPrice(price)} грн</div>
  </div>
);

export default Price;
